import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import AppButton from '../../styles/common/AppButton';
import editImage from '../../images/common/edit_fill.svg';
import boardImage from '../../images/common/board.svg';
import callImage from '../../images/common/call_white_24dp.svg';
import { PAGE_PATH, REMOTE_COMMAND } from '../../lib/constants';
import ColorSF2 from '../../styles/common/ColorSF2';
import {
  Main,
  ScrolledBody,
  Table,
  Thead,
  TheadTr,
  Tbody,
  TbodyTr,
  ThFavoriteName,
  TdFavoriteName,
  FavoriteNameWrapper,
  FavoriteName,
  FavoriteMember,
  ButtonImage,
  SortWrapper,
} from './styles/FavoriteListsStyles';

const FavoriteLists = ({
  userInfo,
  favorites,
  openFavoriteDialog,
  openBlackboardList,
}) => {
  const operatorsInGroup = useSelector(state => state.operator.operators);

  return (
    <Main className="FavoriteLists">
      <Table>
        <Thead>
          <TheadTr>
            <ThFavoriteName>
              <SortWrapper
                className="clickableItem"
                id="operatorOperatorNameSortMarkClick"
                role="presentation"
              >
                <FormattedMessage id="operator.dashboard.operators.title" />
              </SortWrapper>
            </ThFavoriteName>
          </TheadTr>
        </Thead>
      </Table>
      <ScrolledBody>
        <Table>
          <Tbody>
            {favorites &&
              favorites.map(list => {
                const { id, name, groupId } = list;
                const members = list.members || [];
                // 現在選択中のグループに所属しているオペレーターのみを表示する
                // 暫定対応として、フロント側でフィルタリングしているが、バックエンド側でお気に入り内のグループ外のオペレーターを削除したい
                const filteredMembers = members.filter(member =>
                  operatorsInGroup.some(
                    operatorInGroup =>
                      operatorInGroup.operatorId === member.operatorId,
                  ),
                );
                const key = `favorite-${id}`;
                const operatorIds = filteredMembers
                  .map(member => member.operatorId)
                  .filter(operatorId => userInfo.operatorId !== operatorId);
                const stringifyOperatorIds =
                  (operatorIds.length > 0 && JSON.stringify(operatorIds)) || '';
                return (
                  <TbodyTr key={key}>
                    <TdFavoriteName>
                      <FavoriteNameWrapper>
                        <FavoriteName>{name || ''}</FavoriteName>
                        <FavoriteMember>
                          {filteredMembers &&
                            filteredMembers
                              .sort((a, b) =>
                                a.operatorId < b.operatorId ? -1 : 1,
                              )
                              .map(member => member.operatorName)
                              .join(', ')}
                        </FavoriteMember>
                        <AppButton
                          small
                          bgColor={ColorSF2.white}
                          id="editButton"
                          className="button"
                          color={ColorSF2.navyBlue}
                          borderColor={ColorSF2.white}
                          onClick={() =>
                            openFavoriteDialog({
                              id,
                              name,
                              operatorIds,
                              groupId,
                            })
                          }
                        >
                          <ButtonImage src={editImage} alt="edit" />
                          <FormattedMessage id="operator.dashboard.remote.edit" />
                        </AppButton>
                        <AppButton
                          small
                          className="button"
                          borderColor={ColorSF2.navyBlue}
                          bgColor={ColorSF2.white}
                          color={ColorSF2.black}
                          onClick={() =>
                            openBlackboardList(stringifyOperatorIds, id)
                          }
                        >
                          <ButtonImage src={boardImage} alt="board" />
                          <FormattedMessage id="operator.dashboard.remote.blackboard" />
                        </AppButton>
                        <Link
                          target="_blank"
                          to={`${PAGE_PATH.DS_REMOTE}/pre/${REMOTE_COMMAND.caller}?operatorIds=${stringifyOperatorIds}&favoriteId=${id}`}
                        >
                          <AppButton className="button" small>
                            <ButtonImage src={callImage} alt="call" />
                            <FormattedMessage id="operator.dashboard.remote.call" />
                          </AppButton>
                        </Link>
                      </FavoriteNameWrapper>
                    </TdFavoriteName>
                  </TbodyTr>
                );
              })}
          </Tbody>
        </Table>
      </ScrolledBody>
    </Main>
  );
};

FavoriteLists.propTypes = {
  userInfo: PropTypes.object.isRequired,
  favorites: PropTypes.array.isRequired,
  openFavoriteDialog: PropTypes.func.isRequired,
  openBlackboardList: PropTypes.func.isRequired,
};

export default FavoriteLists;
